module.exports = __webpack_public_path__ + "static/staff-1-081ace3d3afd389c382036a68869cf97.png";